(function () {
	function init() {
		const forms = document.querySelectorAll('form.js-site-form, #demo-request-form');
		if (!forms.length) return;

		const emailRe = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

		forms.forEach(function (form) {
			bindForm(form);
		});

		function bindForm(form) {
			const status = form.querySelector('.form-status');
			const fields = Array.prototype.slice.call(
				form.querySelectorAll('input, select, textarea')
			);

			// Don't allow past dates on any date picker in this form.
			form.querySelectorAll('input[type="date"]').forEach(function (dateField) {
				const now = new Date();
				now.setMinutes(now.getMinutes() - now.getTimezoneOffset());
				dateField.min = now.toISOString().slice(0, 10);
			});

			function validate(field) {
				const value = field.value.trim();
				const label = labelFor(field);

				if (!value) return label + ' is required.';
				if (field.type === 'email' && !emailRe.test(value)) {
					return 'Please enter a valid email address.';
				}
				if (field.type === 'tel' && value.replace(/\D/g, '').length < 7) {
					return 'Please enter a valid phone number.';
				}
				return '';
			}

			function labelFor(field) {
				const label = form.querySelector('label[for="' + field.id + '"]');
				return label ? label.textContent.trim() : 'This field';
			}

			function setError(field, message) {
				const wrapper = field.parentNode;
				const errorEl = wrapper.querySelector('.field-error');
				wrapper.classList.toggle('has-error', !!message);
				field.setAttribute('aria-invalid', message ? 'true' : 'false');
				if (errorEl) errorEl.textContent = message;
			}

			fields.forEach(function (field) {
				field.addEventListener('blur', function () {
					if (field.dataset.touched) setError(field, validate(field));
				});
				function onChange() {
					field.dataset.touched = 'true';
					if (field.getAttribute('aria-invalid') === 'true') {
						setError(field, validate(field));
					}
				}
				field.addEventListener('input', onChange);
				field.addEventListener('change', onChange);
			});

			form.addEventListener('submit', function (e) {
				e.preventDefault();

				let firstInvalid = null;
				fields.forEach(function (field) {
					field.dataset.touched = 'true';
					const message = validate(field);
					setError(field, message);
					if (message && !firstInvalid) firstInvalid = field;
				});

				if (firstInvalid) {
					if (status) {
						status.textContent = 'Please fix the highlighted fields.';
						status.className = 'form-status is-error';
					}
					firstInvalid.focus();
					return;
				}

				// TODO: POST to Mautic here (endpoint not set up yet). For now we
				// just acknowledge a successful, fully-validated submission.
				if (status) {
					status.textContent = form.getAttribute('data-success') || 'Thanks! Your request has been received.';
					status.className = 'form-status is-success';
				}
				form.reset();
				fields.forEach(function (field) {
					delete field.dataset.touched;
					setError(field, '');
				});
			});
		}
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', init);
	} else {
		init();
	}
})();
